/**
 * DEV-1090. i18n отчёта конверсии лендингов (под-таб «Лендинги» раздела «Отчёты»).
 * Overlay-модуль: подмешивается deepMerge поверх базовых локалей (reports.*),
 * чтобы не раздувать монолитные ru/en/vn.
 */
export const landingsAnalyticsMessages = {
  ru: {
    reports: {
      tabs: { landings: 'Лендинги' },
      landings: {
        subtitle: 'Просмотры лендингов и заявки с них',
        sinceNote: 'Статистика собирается с июля 2026',
        kpiViews: 'Просмотры',
        kpiLeads: 'Лиды',
        kpiConversion: 'Конверсия',
        tableTitle: 'Площадки',
        colSlug: 'Лендинг',
        colViews: 'Просмотры',
        colLeads: 'Лиды',
        colConversion: 'Конверсия',
        empty: 'Пока нет данных',
        emptyDescription: 'Статистика появится, когда лендинги начнут собирать просмотры и заявки.',
      },
    },
  },
  en: {
    reports: {
      tabs: { landings: 'Landings' },
      landings: {
        subtitle: 'Landing page views and leads they bring',
        sinceNote: 'Statistics collected since July 2026',
        kpiViews: 'Views',
        kpiLeads: 'Leads',
        kpiConversion: 'Conversion',
        tableTitle: 'Landing pages',
        colSlug: 'Landing',
        colViews: 'Views',
        colLeads: 'Leads',
        colConversion: 'Conversion',
        empty: 'No data yet',
        emptyDescription:
          'Statistics will appear once landing pages start collecting views and leads.',
      },
    },
  },
  vn: {
    reports: {
      tabs: { landings: 'Trang đích' },
      landings: {
        subtitle: 'Lượt xem trang đích và khách hàng tiềm năng từ đó',
        sinceNote: 'Thống kê được thu thập từ tháng 7 năm 2026',
        kpiViews: 'Lượt xem',
        kpiLeads: 'Khách tiềm năng',
        kpiConversion: 'Chuyển đổi',
        tableTitle: 'Trang đích',
        colSlug: 'Trang đích',
        colViews: 'Lượt xem',
        colLeads: 'Khách tiềm năng',
        colConversion: 'Chuyển đổi',
        empty: 'Chưa có dữ liệu',
        emptyDescription:
          'Thống kê sẽ xuất hiện khi các trang đích bắt đầu thu thập lượt xem và khách hàng tiềm năng.',
      },
    },
  },
}
